// Top header. Mobile variant shows logo + user menu; sidebar variant shows
// just the logo (user menu lives at the bottom of the sidebar instead).

import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { Logo } from './Logo';
import { UserMenu } from './UserMenu';
import { NotificationBell } from './NotificationBell';

interface HeaderProps {
  variant: 'mobile' | 'sidebar';
  className?: string;
  /** Pad the mobile header below the status bar. Off when something else
   *  (the emulation banner) already sits above it at the top of the screen. */
  safeTop?: boolean;
}

export function Header({ variant, className, safeTop = true }: HeaderProps) {
  return (
    <header
      className={clsx(
        'flex items-center justify-between bg-white',
        // Bottom divider only on the mobile header; the desktop sidebar variant
        // sits flush under the logo with no rule (IMP-035).
        // `box-content` makes the status-bar inset add to the 56px row instead
        // of being taken out of it: with the default border-box sizing a 47px
        // iPhone inset left 9px for 40px controls, which spilled up under the
        // status bar in iOS Safari and could not be tapped.
        variant === 'mobile'
          ? clsx('box-content h-14 px-4 border-b border-cloud', safeTop && 'pt-safe')
          : 'h-16 px-4',
        className,
      )}
    >
      <Link to="/" className="hover:opacity-80 active:scale-95 transition-all">
        {/* Desktop sidebar logo is larger (IMP-049 tweak); the mobile header
            stays compact to leave room for the bell + user menu. */}
        <Logo height={variant === 'sidebar' ? 40 : 34} />
      </Link>
      {variant === 'mobile' && (
        <div className="flex items-center gap-1">
          <NotificationBell />
          <UserMenu variant="compact" />
        </div>
      )}
    </header>
  );
}
